import Modal from '../Utils/Modal';
import '../../styles/salesmanModal.scss';
import { connect } from 'react-redux';

const FreshWorksHookModal = (props) => (
  <Modal {...props}>
    <div className='modal-container freshWorksModal'>
      <div id={'freshWorksHook'} className={'freshWorksHook-wrapper'}></div>
    </div>
  </Modal>
);

export default connect()(FreshWorksHookModal);
